import PurchaseOptions from '@r1-frontend/ui-react/components/costs/PurchaseOptions';
import { TPeriod } from '@r1-frontend/ui-react/components/costs/PurchaseOptions/types';

import { useCtxSelector } from '../hooks';
import getEntityPurchaseOptions from '../selectors/getEntityPurchaseOptions';
import { EEntity } from '../types/EEntity';

type TPurchaseOptionsContainerProps = {
    entityName: Extract<EEntity, EEntity.routers | EEntity.decoders>,
    id: number,
    onSelect: (cost: number, period: TPeriod) => void,
};

const PurchaseOptionsContainer = ({ entityName, id, onSelect }: TPurchaseOptionsContainerProps): JSX.Element => {
    const options = useCtxSelector(getEntityPurchaseOptions(entityName, id));

    return <PurchaseOptions options={options} onSelect={onSelect}/>;
};

export default PurchaseOptionsContainer;
